import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-area0",
  "use": "icon-area0-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-area0\"><path d=\"M698.688 448C593.088 448 512 534.4 512 640l0 192 0 64 58.688 0 320 0L960 896l0-64 0-192c0-105.6-91.712-192-197.312-192L698.688 448zM896 640l0 192-192 0 0-128-64 0 0 128L576 832l0-192c0-70.592 52.096-128 122.688-128l64 0C833.28 512 896 569.408 896 640zM1024 960l0 64L448 1024l0-64L1024 960zM448 896 384 896 384 512l97.792 0C470.72 531.84 462.144 553.152 456.512 576L448 576l0 64L448 896zM192 896l192 0 0 64L352 960 128 960 128 512 0 512l480-512 377.536 402.688C827.904 390.976 796.032 384 762.688 384l-10.432 0L480 93.568 147.712 448 192 448l0 32L192 896z\" p-id=\"37354\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-area0.svg
// module id = fijW
// module chunks = 175